import * as React from 'react';
import { ScheduledAtArgValue } from './ScheduledAtArgValue';
import { TemplateArgValue } from './TemplateArgValue';

export { ArgFieldLabel, ArgFieldValue } from './ArgField';

export type ApprovalArgRenderer = (value: unknown) => React.ReactElement;

const scheduledAt: ApprovalArgRenderer = (value) => <ScheduledAtArgValue scheduledAt={String(value ?? '')} />;

const renderersByToolName: Record<string, Record<string, ApprovalArgRenderer>> = {
  enqueue_email: {
    scheduledAt,
  },
  enqueue_email_with_template: {
    scheduledAt,
    templateId: (value) => <TemplateArgValue templateId={String(value ?? '')} />,
  },
};

export function approvalArgRenderer(toolName: string, argName: string): ApprovalArgRenderer | undefined {
  return renderersByToolName[toolName]?.[argName];
}
